import { useEffect, useState } from 'react';
import ww from "./assets/WW.jpg";

const HeroSection = () => {
  const words = ["Today", "Tomorrow"];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="bg-[#FFF6EF] font-poppins">
      <div className="mx-auto flex max-w-7xl flex-col-reverse items-center gap-8 px-4 py-16 md:flex-row">
        {/* Text Section */}
        <div className="w-full md:w-6/12 md:ml-10 text-center md:text-left">
          <p className="uppercase text-sm text-[#1c1c1c] mb-2 tracking-wide">
            Healthcare
          </p>

          <h2 className="text-3xl md:text-4xl font-bold text-[#1c1c1c] leading-snug mb-2">
            Healthcare with innovative <br /> solutions for a healthier of{" "}
            <span className="inline-block h-[60px] overflow-hidden relative align-middle">
              <div
                className="transition-transform duration-700 ease-in-out"
                style={{
                  transform: `translateY(-${index * 60}px)`,
                }}
              >
                {words.map((word, i) => (
                  <div
                    key={i}
                    className="h-[60px] text-[#F7BC2C] flex items-center text-[40px] sm:text-[44px] lg:text-[48px] font-bold"
                  >
                    {word}
                  </div>
                ))}
              </div>
            </span>
          </h2>

          <p className="max-w-xl mx-auto md:mx-0 text-[15px] leading-relaxed text-gray-700">
            The approach allows institutions to streamline administrative tasks,
            improve data management and enhance student learning experiences.
          </p>
        </div>

        {/* Image Section */}
        <div className="w-full md:w-6/12 flex justify-center">
          <img
            src={ww}
            alt="Healthcare Illustration"
            className="w-4/5 md:w-[60%] lg:w-[70%]"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
